import api from "./api";

const transactionSlipService = {
  get: (jwttoken) =>
    api.get(`/transaction-slip`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
};

export default transactionSlipService;
